import 'core-js/stable';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/styles/index.scss';

import { fnEnableConsole, fnDisableConsole } from '@/utils/console';
if (process.env.NODE_ENV === 'production') {
  fnDisableConsole();
} else {
  fnEnableConsole();
}

import './globalExceptionFilter.js';
import './routerGuardFilter.js';
import './globalDirectives.js';
import './globalComponents.js';

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
